import { mergeClasses } from '@/utils/style';
import { MDXRemote, type MDXRemoteSerializeResult } from 'next-mdx-remote';
import { Link } from '@/components/links';
import { Text } from '@/components/typography';

interface Props {
	content: MDXRemoteSerializeResult;
	listVariant?: 'default' | 'grid';
}

export function MarkdownContent(props: Props) {
	const { content, listVariant = 'default' } = props;
	return (
		<MDXRemote
			components={{
				ul: ({ children }) => (
					<ul
						className={mergeClasses(
							listVariant === 'grid' && 'row-auto grid grid-cols-2 gap-2 lg:grid-cols-3',
							listVariant === 'default' &&
								'mb-2 list-disc space-y-3 pl-5 marker:text-blue-500 md:mb-4'
						)}
					>
						{children}
					</ul>
				),
				li: ({ children }) => (
					<li
						className={mergeClasses(
							'rounded-lg py-1',
							listVariant == 'grid' && 'bg-blue-100 px-4',
							listVariant == 'default' && 'marker:text-blue-500'
						)}
					>
						{children}
					</li>
				),
				ol: ({ children }) => (
					<ol
						className={mergeClasses(
							listVariant === 'default' && 'mb-2 list-disc space-y-3 pl-5 md:mb-4'
						)}
					>
						{children}
					</ol>
				),
				strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
				h2: ({ children }) => <h2 className="mb-4 text-lg font-semibold lg:text-xl">{children}</h2>,
				h3: ({ children }) => (
					<h3 className="mb-4 text-base font-semibold lg:text-lg">{children}</h3>
				),
				h4: ({ children }) => (
					<h4 className="mb-4 text-sm font-semibold lg:text-base">{children}</h4>
				),
				p: ({ children }) => <Text className="mb-4">{children}</Text>,
				a: ({ children, href }) => {
					return (
						<Link
							to={href || ''}
							className="text-blue-600 underline transition hover:text-blue-800"
							target="_blank"
							analyticsParam="markdownLink"
							testId="markdownLink"
						>
							{children}
						</Link>
					);
				},
			}}
			{...content}
		/>
	);
}
